import { Component, Input, OnInit } from '@angular/core';
import { MoniepointColumnType } from '../../../../../../shared/models/moniepoint-table.model';

@Component({
	selector: 'app-moniepoint-table-special-column',
	templateUrl: './moniepoint-table-special-column.component.html',
	styleUrls: ['./moniepoint-table-special-column.component.scss']
})
export class MoniepointTableSpecialColumnComponent implements OnInit {
	@Input() columnType: MoniepointColumnType;
	@Input() coloredRow: boolean;
	@Input() columnValue: any;
	@Input() rateProcess: any;
	@Input() isMobile: boolean;
	@Input() dateFormat: string;
	readonly STATUS = 'status';
	readonly RATING = 'rating';
	readonly TRANS_TYPE = 'trans-type';
	readonly TERMINAL_TYPE = 'terminal-type';
	readonly RATE = 'rate';
	readonly RATE_BADGE_GREEN = 'rate-badge-green';
	readonly RATE_PROGRESS = 'rate-progress';
	readonly AMOUNT = 'amount';
	readonly REF = 'ref';
	readonly DATE = 'date';

	constructor() {
	}

	ngOnInit(): void {
	}

	refineTerminalTypeName(type) {
		switch (type) {
			case 'WEB_DEVICE':
				return 'web';
			default:
				return type.toString();
		}
	}

	convertToRefineName(type) {
		switch (type) {
			case 'INSURANCE PREMIUM':
				return type.split(' ').join('_').toLowerCase();
			case 'POS TRANSFER':
				return type.split(' ').join('_').toLowerCase();
			case 'CARD TRANSFER':
				return type.split(' ').join('_').toLowerCase();
			default:
				return type?.toLowerCase();
		}
	}

	getRateValue(rate) {
		let newRate = 0;
		try {
			newRate = Number(rate);
		}
		catch (err) {
			console.log('error', err);
		}
		return newRate;
	}

	getRateColor(rate) {
		if (rate.toString().toLowerCase() === 'n/a') {
			return 'rate_green';
		}

		const newRate = this.getRateValue(rate);

		return this.convertRateToColor(newRate);
	}

	getRatingProcessBg() {
		const rate = this.rateProcess || 'N/A';
		if (rate.toString().toLowerCase() === 'n/a') {
			return 'background:#1EB12D';
		}
		let classBgColor;
		if (rate < 50) {
			classBgColor = 'background:#E94444';
		}
		else if (rate < 79) {
			classBgColor = 'background:#F08922';
		}
		else if (rate >= 80) {
			classBgColor = 'background:#1EB12D';
		}

		return classBgColor;

	}

	getRatingProcessWidth() {
		const rate = this.rateProcess || 'N/A';
		if (rate.toString().toLowerCase() === 'n/a') {
			return 'max-width:2px';
		}
		let newRate = this.getRateValue(rate);
		newRate = (newRate / 100) * 250;
		return `max-width:${newRate}px`;
	}

	convertRateToColor(rate: number) {
		let classColor;
		if (rate < 50) {
			classColor = 'rate_red';
		}
		else if (rate < 79) {
			classColor = 'rate_orange';
		}
		else if (rate >= 80) {
			classColor = 'rate_green';
		}

		return classColor;
	}

}
